module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3.8f007f3f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-2-3.mp3
// module id = 554
// module chunks = 0